// StaticSniplet.tsx
import { useState, useEffect } from 'react';
import { Notification, NotificationProps } from '@oms/ui-notification';
import { isMarkup, sanitize } from '@oms/utils';
import moment from 'moment';
import styled from '@xstyled/emotion';

export interface SnipletType {
  id: number;
  name: string;
  published: boolean;
  publishedFrom?: string;
  publishedTo?: string;
  body?: string; // Uproszczone bezpośrednie body
}

interface Props {
  name: string;
}

function isSnipletPublished(sniplet: SnipletType) {
  if (!sniplet) return false;
  if (!sniplet.published) return false;

  const now = moment();
  const from = sniplet.publishedFrom;
  const to = sniplet.publishedTo;
  const isPublishedFrom = !from || moment(from).isBefore(now);
  const isPublishedTo = !to || moment(to).isAfter(now);

  return isPublishedFrom && isPublishedTo;
}

const StyledNotification = styled(Notification)`
  div {
    min-width: 0;
  }
  a {
    display: inline-block;
    overflow-wrap: anywhere;
  }
  img {
    max-width: 100%;
  }
`;

export const StaticSniplet = ({
  name,
  ...props
}: Props & Partial<NotificationProps>) => {
  const [sniplets, setSniplets] = useState<SnipletType[]>([]);

  useEffect(() => {
    fetch('/sniplets.json')
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch sniplets');
        return res.json();
      })
      .then(data => setSniplets(data))
      .catch(err => console.error(err));
  }, []);

  const sniplet = sniplets.find(s => s.name === name);
  if (!sniplet || !isSnipletPublished(sniplet)) return null;

  const body = sniplet.body;
  if (!body) return null;

  return (
    <StyledNotification title="" {...props}>
      {!isMarkup(body) ? (
        body
      ) : (
        <div dangerouslySetInnerHTML={sanitize(body)} />
      )}
    </StyledNotification>
  );
};
